import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { footerCircuit, stickers } from '@/lib/circuits';

/**
 * Couche de stickers entre l'en-tête et le pied de page. Elle commence sous
 * la première section de la page (la bannière reste nette), comme dans la
 * maquette. À poser en premier enfant de `<main>`.
 */
export function StickerLayer() {
  const layer = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const element = layer.current;
    const host = element?.parentElement;
    if (!element || !host) return;

    const place = () => {
      const first = element.nextElementSibling as HTMLElement | null;
      element.style.top = `${String(first ? first.offsetTop + first.offsetHeight : 0)}px`;
    };

    place();
    const observer = new ResizeObserver(place);
    observer.observe(host);
    return () => observer.disconnect();
  }, [pathname]);

  return (
    <div
      ref={layer}
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 bottom-0 z-0 overflow-hidden"
    >
      {stickers.map((sticker, index) => (
        <div
          key={index}
          className="pcb"
          style={
            {
              left: `${String(sticker.left)}%`,
              top: `${String(sticker.top)}%`,
              animationDelay: sticker.delay,
              ...sticker.vars,
            }
          }
        >
          <div className="pcb-in">
            <svg viewBox="0 0 100 100" dangerouslySetInnerHTML={{ __html: sticker.svg }} />
          </div>
        </div>
      ))}
    </div>
  );
}

/** Pistes du pied de page, masquées au centre pour laisser le texte lisible. */
export function FooterCircuit() {
  return (
    <svg
      className="ft-pcb"
      viewBox="0 0 1440 420"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: footerCircuit }}
    />
  );
}
